import React from 'react';
import { useSelector } from 'react-redux';

import { SUPER_OFFERS, APPLY_TO, DAILY_SPECIALS } from 'src/redux/actions/tabs';
import DailyOffersContainer from 'src/containers/DailyOffersContainer';
import SuperOffersContainer from 'src/containers/SuperOffersContainer';
import Pagination from 'src/components/Pagination/PaginationWrapper';
import ApplyToContainer from 'src/containers/ApplyToContainer';
import './ListingContainer.scss';


const ListingContainer = () => {
  const { tab } = useSelector(state => ({
    tab: state.tabs.activeTab
  }), (previous, next) => previous.tab === next.tab);

  return (
    <div data-test="section-daily-specials" styleName="offers">
      {
        tab === DAILY_SPECIALS && <Pagination><DailyOffersContainer /></Pagination>
      }
      {
        tab === SUPER_OFFERS && <Pagination><SuperOffersContainer /></Pagination>
      }
      {
        tab === APPLY_TO && <ApplyToContainer />
      }
    </div>
  );
};

export default ListingContainer;
